export const ifNot = (condition: boolean, errorMessage: string) => {
    if (!condition) {
        throw new Error(errorMessage);
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utilities/error.ts